import { render } from "./Logo.vue?vue&type=template&id=59edc81f"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=59edc81f&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script